import Component from './component.vue';
import {
  Events,
  Item as _Item,
  Items as _Items,
  Props as _Props,
} from './types';

type Item = _Item;
type Items = _Items;
type Props = _Props;

export {
  Events,
  Item,
  Items,
  Props,
};
export default Component;



// WEBPACK FOOTER //
// ./src/components/parts/tab/menu/index.ts